var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tame-continuous-color-legend"})
}
var staticRenderFns = []

export { render, staticRenderFns }